import React from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  spanningTable: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    '& > div': {
      textAlign: 'center',
    },
  },
  spannTableHead: {
    borderTop: '1px solid #e5e8eb',
    marginTop: 3,
    paddingTop: 4,
  },
}));

const SpanningTableContents = (props) => {
  const classes = useStyles();
  const { topTitle, type = 'body', style, children } = props;
  return (
    <>
      {type === 'head' && <div>{topTitle}</div>}
      <div
        className={clsx(
          classes.spanningTable,
          type === 'head' && classes.spannTableHead
        )}
        style={style}
      >
        {children}
      </div>
    </>
  );
};

export default SpanningTableContents;
